import { setInfoBookedNow } from "@/utils/booked";
import { getToken } from "@/utils/wapAuth";

const state = {
  list_golfer_booking: {
    list_golfer: [],
    checked: false
  },
  list_golfer: [],
  list_golfer_out: []
};

const mutations = {
  UPDATE_LIST: (state, new_data) => {
    state.list_golfer_booking = new_data;
    if (
      !new_data.list_golfer ||
      (new_data.list_golfer && new_data.list_golfer.length == 0)
    ) {
      console.log("vào đaay");
      const defaultGolfer = {
        id: getToken().vga,
        vga: getToken().vga,
        id_display: getToken().id_display,
        user_id: getToken().id_display,
        name: getToken().fullname,
        avatar: getToken().avatar,
        hio_list: []
      };
      state.list_golfer_booking.list_golfer = [defaultGolfer];
      setInfoBookedNow({ ...new_data, list_golfer: [defaultGolfer] });
    } else {
      setInfoBookedNow(new_data);
    }
  },
  ADD_ALL_GOLFER: (state, data) => {
    state.list_golfer = data;
  },
  PUSH_GOLFER: (state, data) => {
    state.list_golfer.push(data);
  },
  REMOVE_GOLFER: (state, id) => {
    const index = state.list_golfer.findIndex(i => i.user_id == id);
    console.log("index______", index);

    if (index !== -1) {
      state.list_golfer.splice(index, 1);
    }
  },
  ADD_ALL_GOLFER_OUT: (state, data) => {
    state.list_golfer_out = data;
  },
  PUSH_GOLFER_OUT: (state, data) => {
    state.list_golfer_out.push(data);
  },
  REMOVE_GOLFER_OUT: (state, item) => {
    state.list_golfer_out.splice(state.list_golfer_out.indexOf(item), 1);
  },
  RESET_DETAIL: state => {
    state.list_golfer_booking = {
      list_gofer: [],
      checked: false,
      showServiceIcon: false,
      tee_id: null,
      money: null
    };
  }
};

const actions = {
  update_list_golfer_booking(context, data) {
    context.commit("UPDATE_LIST", data);
  },
  add_all_golfer(context, data) {
    context.commit("ADD_ALL_GOLFER", data);
  },
  push_golfer(context, data) {
    context.commit("PUSH_GOLFER", data);
  },
  remove_golfer(context, data) {
    context.commit("REMOVE_GOLFER", data);
  },
  add_all_golfer_out(context, data) {
    context.commit("ADD_ALL_GOLFER_OUT", data);
  },
  add_golfer_default(context) {
    const defaultGolfer = {
      id_display: getToken().id_display,
      user_id: getToken().vga,
      fullname: getToken().fullname
    };
    context.commit("ADD_ALL_GOLFER", [defaultGolfer]);
  },
  push_golfer_out(context, data) {
    context.commit("PUSH_GOLFER_OUT", data);
  },
  remove_golfer_out(context, data) {
    context.commit("REMOVE_GOLFER_OUT", data);
  },
  reset_detail_booked(context) {
    context.commit("RESET_DETAIL");
  }
};

export default {
  state,
  mutations,
  actions
};
